module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("Introduction  "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_05_int#int"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("1.  The Great Depression: Misunderstanding Deflation  "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_06_chp01#chp01"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("2.  The Triumph of Keynesian Economics  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_07_chp02#chp02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("3.  Inflation: The Downfall of Keynesian Economics  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_08_chp03#chp03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("4.  The Conservative Counterrevolution  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_09_chp04#chp04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("5.  The Rise and Fall of Supply-Side Economics  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_10_chp05#chp05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("6.  Starving the Beast Didn't Work  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_11_chp06#chp06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("7.  Dealing with Tomorrow’s Economic Crisis  "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_12_chp07#chp07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("Appendices "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_13_app#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("List of Abbreviations "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_14_abb#abb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("Notes "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_15_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_vm._v("Index "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/OEBPS/html/9780230249226_16_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("257")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d57de93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/html/9780230249226_04_toc.vue
// module id = 69
// module chunks = 0